import {createMultiStyleConfigHelpers} from '@chakra-ui/styled-system';

import {tokens} from '../../../generated/light';

import {numbersAnatomy} from './anatomy';
import {vars} from './css-vars';

const {definePartsStyle, defineMultiStyleConfig} = createMultiStyleConfigHelpers(numbersAnatomy.keys());

const baseStyle = definePartsStyle(() => {
  return {
    container: {
      [vars.gap.variable]: `space.space-100`,
      display: `flex`,
      flexDirection: `column`,
      alignItems: `flex-start`,
    },
    numbersContainer: {
      display: `flex`,
      gap: vars.gap.reference,
    },
    label: {
      color: `text.tertiary`,
      fontSize: tokens.core.fontSizes.text.sm,
      fontWeight: tokens.core.fontWeights.text.sm,
      lineHeight: tokens.core.lineHeights.text.sm,
    },
    left: {
      color: `text.primary`,
      fontSize: tokens.core.fontSizes.display.sm,
      fontWeight: `700`,
      lineHeight: tokens.core.lineHeights.display.sm,
    },
    right: {
      color: `text.secondary`,
      display: `flex`,
      gap: `space.space-100`,
      alignItems: `center`,
      alignSelf: `flex-end`,
      fontSize: tokens.core.fontSizes.text.lg,
      lineHeight: tokens.core.lineHeights.text.lg,
    },
  };
});

export const numbersTheme = defineMultiStyleConfig({
  baseStyle,
});
